<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <p class="dialog-content mb-0" style="white-space: pre-line">{{ data.content }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @for (button of data.buttonsAlert; track $index) {
    <button type="button" class="btn" [class.btn-outline-secondary]="button === 'Cancelar'" [class.btn-primary]="button !== 'Cancelar'" (click)="dialogSelfRef.close(button)">{{ button }}</button>
  }
</mat-dialog-actions>
